export const RumTiming = {
  SURVEY_LOADED: 'survey_loaded',
  FIRST_QUESTION_VISIBLE: 'first_question_visible',
};

export const RumAction = {
  PAGE_ADVANCED: 'page_advanced',
  SUBMIT_ATTEMPTED: 'submit_attempted',
  SUBMIT_SUCCEEDED: 'submit_succeeded',
  SUBMIT_FAILED: 'submit_failed',
  SAVE_BEACON_SENT: 'save_beacon_sent',
  EXPERIMENT_VIEWED: 'experiment_viewed',
};
